import {updateSlideInList, setNewCurrentNode} from '../../utilities';
import {
  PROTOCOL_SLIDE_TYPES,
  fetchProtocolScene,
  fetchComponentIds,
} from '@learningblocks/protocol-constants/lib/Utilities';
export function slideTwoApplyHint(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  const allSlides = updateAllSlides(protocolSection.allSlides, payload);
  return {
    ...protocolSection,
    allSlides,
  };
}

function getTotalHintsUsed(previousHintsUsed, optionDisabled) {
  if (optionDisabled) {
    return previousHintsUsed + 1;
  }
  return previousHintsUsed;
}

function updateAllSlides(allSlides, payload) {
  const slideTwo = fetchProtocolScene(allSlides, PROTOCOL_SLIDE_TYPES.TWO);
  const designSlideTwo = updateDesignSlideTwo(slideTwo, payload);
  const updatedAllSlides = updateSlideInList(allSlides, designSlideTwo);
  return updatedAllSlides;
}

function updateDesignSlideTwo(designSlideTwo, payload) {
  payload.disabledOption = false;
  let slideTree = updateSlideTree(designSlideTwo.slideTree, payload);
  const hintsUsed = getTotalHintsUsed(
    designSlideTwo.hintsUsed,
    payload.disabledOption
  );
  return {
    ...designSlideTwo,
    hintsUsed,
    slideTree,
  };
}

function updateSlideTree(slideTree, payload) {
  const updateAllNodes = (node) => {
    if (node.current) {
      node.nodeOptions = disableAnInvalidNodeOption(node, payload);
    }
    return {...node};
  };

  const updateTreeGroup = (treeGroup) => ({
    ...treeGroup,
    groupNodes: treeGroup.groupNodes.map(updateAllNodes),
  });

  let updatedSlideTree = slideTree.map(updateTreeGroup);
  updatedSlideTree = setNewCurrentNode(updatedSlideTree);
  return updatedSlideTree;
}

function disableAnInvalidNodeOption(node, payload) {
  const allValidOptions = fetchComponentIds(node.nodeComponents);
  const {nodeOptions} = node.nodeOptions.reduce(
    (acc, option) => {
      if (
        acc.updated === false &&
        allValidOptions.includes(option.id) === false &&
        option.optionDisabled === false
      ) {
        option.optionDisabled = true;
        acc.updated = true;
        payload.disabledOption = true;
      }
      acc.nodeOptions.push({...option});
      return acc;
    },
    {nodeOptions: [], updated: false}
  );
  return nodeOptions;
}
